import { render, staticRenderFns } from "./sdk.vue?vue&type=template&id=189ee663&scoped=true"
import script from "./sdk.vue?vue&type=script&lang=js"
export * from "./sdk.vue?vue&type=script&lang=js"
import style0 from "./sdk.vue?vue&type=style&index=0&id=189ee663&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ee663",
  null
  
)

export default component.exports